import { useQuery } from 'react-query';
import { network } from 'services/network';

const getRelationshipCountChangesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getTopRelationshipCountChanges', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryRelationshipCountChangesTableData = (params) => {
    return useQuery(['relationshipCountChangesTableData', params], () => getRelationshipCountChangesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
